import PriceScans from "./PriceScans";
export default PriceScans;
